import { CommonPullupMenuComponent } from 'src/app/pages/modal-screens/common-pullup-menu/common-pullup-menu.component';
import { Router, ActivatedRoute } from '@angular/router';
import { SponsorInfo } from './../../../../data/SponsorInfo';
import { CompetitionInfo } from './../../../../data/competition-data';
import { RemoteHttpService } from './../../../../remote-http';
import { isPresent } from 'src/providers/common-service';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  CompetitionData,
  CompetitionSponsorData,
  CompetitionSponsorInfo,
} from 'src/data/mygolf.data';
import { Browser } from '@capacitor/browser';
import { AppCustomizerService } from 'services/app-customizer-service/app-customizer.service';
@Component({
  selector: 'app-competition-sponsors',
  templateUrl: './competition-sponsors.page.html',
  styleUrls: ['./competition-sponsors.page.scss'],
})
export class CompetitionSponsorsPage implements OnInit {
  public competition: CompetitionInfo & CompetitionData;
  public show: boolean = false;
  public sponsors: Array<CompetitionSponsorInfo & CompetitionSponsorData> = new Array<
    CompetitionSponsorInfo & CompetitionSponsorData
  >();

  compId: number;
  // constructor(private router: Router) {}
  constructor(
    private nav: NavController,
    private navParams: NavParams,
    private http: RemoteHttpService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private modalCtl: ModalController,
    private platform: Platform,
    private customizerService: AppCustomizerService
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick();
    }

    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.sponsors = this.router.getCurrentNavigation().extras.state.sponsors;

    this.show = isPresent(this.sponsors) ? true : false;
  }

  ngOnInit() {
    if (this.sponsors?.length) {
      this.sponsors?.sort((a, b) => {
        return a?.displaySequence - b?.displaySequence;
      });
    }
  }
  onBackpage() {
    this.location.back();
  }
  onHomeClick() {
    this.customizerService.goToPlayerHome();
    // this.router.navigate(['tabs/player-home'], { replaceUrl: false });
  }
  getSponsorImage(s: CompetitionSponsorInfo) {
    if (!s) return;
    if (s?.imageUrl) return s.imageUrl;
    else if (s?.sponsor?.image) return s.sponsor.image;
  }
  onClickSponsor(s: CompetitionSponsorInfo & CompetitionSponsorData) {
    console.debug("on click sponsor : ", s)
    if(!s) return;
    if(s?.websiteUrl) {
      this.goToSponsorUrl(s?.websiteUrl);
    } else {
      if(s?.sponsor?.address?.webSite) {
      this.goToSponsorUrl(s?.sponsor?.address?.webSite);

      }
    }
  }

  async goToSponsorUrl(websiteUrl?: string) {

        if (!websiteUrl) return;

        const _message = `This will redirect to Sponsor's Website Page. Do you want to proceed?`;

        const modal = await this.modalCtl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
            headerTitle: 'Redirect to external site',
            confirmMessage: _message,
            mode: 'positive-confirmation',
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 250;
          if (document.getElementsByClassName('inner-content')[0])
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then((data: any) => {
          if (data?.data) {
            Browser.open({url: websiteUrl});
          }
        });
  }
}
